export function About() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-block mb-6">
              <div className="flex items-center gap-2 px-4 py-2 bg-rose-100 rounded-full">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-lightbulb-line text-xl text-rose-800"></i>
                </div>
                <span className="text-sm font-semibold text-rose-800 uppercase tracking-wide">About Our Service</span>
              </div>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900 leading-tight" style={{ fontFamily: "'Cinzel', serif" }}>
              <strong className="text-rose-800">Clarity</strong> Through Understanding
            </h2>

            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              In the sacred journey of <strong className="text-rose-700">arranged marriage</strong>, understanding your potential partner is crucial. We provide expert guidance to help you gain <strong className="text-rose-700">clarity</strong> about the person you're considering for marriage.
            </p>

            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Our approach focuses on <strong className="text-rose-700">development through clarity</strong> – helping you understand compatibility, values, and expectations. We don't offer relationship advice; instead, we help you see clearly so you can make informed decisions.
            </p>

            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-rose-100 rounded-full flex-shrink-0">
                  <i className="ri-check-line text-xl text-rose-800"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-1">Expert Consultation</h3>
                  <p className="text-gray-600">Personalized 1-on-1 sessions tailored to your specific situation</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-rose-100 rounded-full flex-shrink-0">
                  <i className="ri-check-line text-xl text-rose-800"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-1">Structured Learning</h3>
                  <p className="text-gray-600">Comprehensive courses to understand the nuances of arranged marriage clarity</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-rose-100 rounded-full flex-shrink-0">
                  <i className="ri-check-line text-xl text-rose-800"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-900 mb-1">Global Reach</h3>
                  <p className="text-gray-600">Serving the Indian market and clients worldwide</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/7e7fc8ea16542d6bbb249ed6496198a7.jpg"
                alt="Clarity for Arranged Marriage Guidance"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-rose-900/20 to-transparent"></div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-gradient-to-br from-rose-200 to-amber-200 rounded-full blur-2xl opacity-60"></div>
            <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-gradient-to-tr from-red-200 to-rose-300 rounded-full blur-2xl opacity-60"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
